import React, { useState } from 'react';
import { IPlaceItem } from '../constants';
import './index.module.less';
import ListItem from './ListItem';

//私有常量

//可抽离的逻辑处理函数/组件

let List = (props: IProps) => {
  //变量声明、解构
  const {
    items,
    selectedLocation,
    onSelectItem,
    onShowSearch,
    onLocationPosition,
  } = props;

  //组件状态
  const [isExpand, setIsExpand] = useState(false);

  //网络IO

  //数据转换

  //逻辑处理函数
  const renderLocations = (): JSX.Element | JSX.Element[] => {
    let locationsItems = null;
    if (items?.length > 0) {
      const tempItems = isExpand ? items : items.slice(0, 1);
      locationsItems = tempItems.map((item: IPlaceItem) => {
        return (
          <ListItem
            key={item.uniqueId}
            item={item}
            onSelect={onSelectItem}
            selectItem={selectedLocation}
            style={isExpand ? {} : { border: 'none' }}
          />
        );
      });
    } else if (items && items.length === 0) {
      locationsItems = <div styleName="empty">无结果</div>;
    }
    return locationsItems;
  };

  //组件Effect

  return (
    <div
      className="flex"
      styleName="modal"
      style={{ height: isExpand ? '70%' : 'auto', paddingTop: 0 }}
    >
      {/* 展开位置List箭头 */}
      <div
        className="flex flex-center"
        styleName="expand-btn"
        onClick={() => setIsExpand(!isExpand)}
      >
        <i
          className="iconfont icon-dibudanchuangzhankai"
          style={isExpand ? { transform: 'rotate(180deg)' } : {}}
        />
      </div>
      <div
        className="flex"
        styleName="search-btn-wrapper"
        onClick={onShowSearch}
      >
        <i className="iconfont icon-sousuo" styleName="input-icon" />
        <div styleName="search-btn">搜索地点名称</div>
      </div>
      <div styleName="list">{renderLocations()}</div>
      <div
        className="flex flex-center"
        styleName="icon-genlocation"
        onClick={onLocationPosition}
      >
        <i className="iconfont icon-dingwei" />
      </div>
    </div>
  );
};

//props类型定义
interface IProps {
  /**
   * 渲染List的位置数据
   */
  items: IPlaceItem[] | null;
  /**
   * 被选中的List位置数据
   */
  selectedLocation: IPlaceItem;
  /**
   * 控制搜索List的显隐
   */
  onShowSearch: () => void;
  /**
   * 点击位置List切换位置事件
   */
  onSelectItem: (item: IPlaceItem, isSearch?: boolean) => void;
  /**
   * 点击回到当前位置事件
   */
  onLocationPosition: () => void;
}

//prop-type定义，可选

export default List;
